import { map } from "lodash";
import {
  Alert,
  Col,
  Form,
  Image,
  OverlayTrigger,
  Row,
  Spinner,
  Tab,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import { useMLSResults } from "../../adapters/uplist";
import { useModal } from "../../hooks";
import CarouselModal from "./CarouselModal";

export const MlsResults = () => {
  const { data, isInitialLoading } = useMLSResults();
  const { handleModal } = useModal();

  if (!data && !isInitialLoading) return null;
  if (isInitialLoading) return <Spinner animation="border" variant="primary" />;
  if (data === "not_found")
    return <Alert variant="info">No MLS Match Found</Alert>;
  return (
    <>
      <Form.Label className="text-muted">Mls Results</Form.Label>
      <Row className="mb-4">
        <Col>
          <Tabs>
            <Tab eventKey="basic" title="Basic" className="border-bottom">
              <Row>
                {!!data.images.length && (
                  <Col xs={3} className="pr-0">
                    <OverlayTrigger
                      overlay={<Tooltip>Click to see more pictures.</Tooltip>}
                    >
                      <Image
                        src={data.images[0]}
                        className="h-100 w-100"
                        style={{ objectFit: "cover", cursor: "pointer" }}
                        onClick={() =>
                          handleModal(<CarouselModal urls={data.images} />, {
                            dialogClassName: "sample-modal",
                            centered: true,
                          })
                        }
                      />
                    </OverlayTrigger>
                  </Col>
                )}
                <Col className="d-flex align-items-center">
                  <Row>
                    <Col xs={12} className="mb-2">
                      {data.address}
                    </Col>
                    <Col xs={12}>
                      <DataRows items={data.basic} xs={4} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey="details"
              title="Details"
              className="p-2 border-bottom"
            >
              <Row>
                <Col xs={6}>
                  <DataRows items={data.details.left} xs={12} />
                </Col>
                <Col xs={6}>
                  <DataRows items={data.details.right} xs={12} />
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey="features"
              title="Features"
              className="p-2 border-bottom"
            >
              <DataRows items={data.details.Features} xs={12} />
            </Tab>
            <Tab eventKey="notes" title="Notes" className="p-2 border-bottom">
              <DataRows items={data.details.Notes} xs={12} />
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

const DataRows = ({ items, ...props }) => {
  return (
    <Row>
      {map(items, (value, name) => (
        <Col key={name} className="mb-2" {...props}>
          <span className="text-muted">{name}:</span> {value}
        </Col>
      ))}
    </Row>
  );
};
